/*
    Mutation naming convention.

    UPDATE_ - Update the complete module store.
    SET_ - Update a single property in the module store.
    RESET_ - Clear the module store back to its original values.

    NOTE: We could of reused mutation names across all modules
    e.g. RESET, UPDATE, ADD to avoid types like SESSION_RESET_SESSION,
    but I think in the long run it is better to explicity state each mutation than be generic.
*/
export const SET_VERSION = 'setVersion';
export const SET_APP_NAME = 'setAppName';
export const SET_API_VERSION = 'setAPIVersion';
export const SET_INITIALISED = 'setInitialised';
export const SET_CONTENT_SEARCH_TEXT = 'setContentSearchText';
export const SET_QUICK_LINK_SEARCH_TEXT = 'setQuickLinkSearchText';
export const SET_CE_VERSION = 'setContenEngineVersion';

export const APP_SET_API_VERSION = `app/${SET_API_VERSION}`;
export const APP_SET_APP_NAME = `app/${SET_APP_NAME}`;
export const APP_SET_CE_VERSION = `app/${SET_CE_VERSION}`;
export const APP_SET_VERSION = `app/${SET_VERSION}`;
export const APP_SET_INITIALISED = `app/${SET_INITIALISED}`;
export const APP_SET_CONTENT_SEARCH_TEXT = `app/${SET_CONTENT_SEARCH_TEXT}`;
export const APP_SET_QUICK_LINK_SEARCH_TEXT = `app/${SET_QUICK_LINK_SEARCH_TEXT}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_SESSION = 'resetSession';
export const SET_IDP_URI = 'setIdpUri';
export const SET_REDIRECT_URI = 'setRedirectUri';
export const SET_FQDN = 'setFqdn';
export const SET_SUBDOMAIN = 'setSubdomain';
export const SET_TOKEN_EXPIRY = 'setTokenExpiry';
export const SET_REFRESH_TOKEN = 'setRefreshToken';
export const SET_INTERRUPT_REFRESH_TOKEN = 'setInterruptRefreshToken';
export const SET_PROFILE = 'setProfile';
export const SET_SESSION_INITIALISED = 'setSessionInitialised';
export const SET_TOKEN = 'setToken';
export const SET_IS_FIRST_LOGIN = 'setIsFirstLogin';
export const SET_IS_LOGIN_BANNER_SHOWN = 'setIsLoginBannerShown';

export const SESSION_RESET_SESSION = `session/${RESET_SESSION}`;
export const SESSION_SET_IDP_URI = `session/${SET_IDP_URI}`;
export const SESSION_SET_REDIRECT_URI = `session/${SET_REDIRECT_URI}`;
export const SESSION_SET_FQDN = `session/${SET_FQDN}`;
export const SESSION_SET_SUBDOMAIN = `session/${SET_SUBDOMAIN}`;
export const SESSION_SET_TOKEN_EXPIRY = `session/${SET_TOKEN_EXPIRY}`;
export const SESSION_SET_REFRESH_TOKEN = `session/${SET_REFRESH_TOKEN}`;
export const SESSION_SET_INTERRUPT_REFRESH_TOKEN = `session/${SET_INTERRUPT_REFRESH_TOKEN}`;
export const SESSION_SET_PROFILE = `session/${SET_PROFILE}`;
export const SESSION_SET_SESSION_INITIALISED = `session/${SET_SESSION_INITIALISED}`;
export const SESSION_SET_TOKEN = `session/${SET_TOKEN}`;
export const SESSION_SET_IS_FIRST_LOGIN = `session/${SET_IS_FIRST_LOGIN}`;
export const SESSION_SET_IS_LOGIN_BANNER_SHOWN = `session/${SET_IS_LOGIN_BANNER_SHOWN}`;

// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_AUTHORISATION = 'resetAuthorisation';
export const SET_ROLE = 'setRole';
export const SET_ORIGINAL_ADMIN_ROLE = 'setOriginalAdminRole';
export const SET_SITE_TYPE = 'setSiteType';
export const SET_DRAFT_MODE = 'setDraftMode';
export const SET_VIEW_TYPE = 'setViewType';

export const AUTHORISATION_SET_ROLE = `authorisation/${SET_ROLE}`;
export const AUTHORISATION_SET_ROLE_SET_ORIGINAL_ADMIN_ROLE = `authorisation/${SET_ORIGINAL_ADMIN_ROLE}`;
export const AUTHORISATION_SET_VIEW_TYPE = `authorisation/${SET_VIEW_TYPE}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_APPEARANCE = 'resetAppearance';
export const SET_PAGE_HISTORY_NAV = 'setPageHistoryNav';
export const SET_SEARCH_PANEL = 'setSearchPanel';
export const SET_FULLSCREEN = 'setFullscreen';
export const SET_ISMOBILE = 'setIsMobile';
export const SET_PREFERENCES_VIEW = 'setPreferencesView';
export const SET_IS_PUBLIC_VIEW_MODE = 'setIsPublicViewMode';
export const SET_IS_LOADING_IMAGES = 'setLoadingImages';

export const APPEARANCE_RESET_APPEARANCE = `appearance/${RESET_APPEARANCE}`;
export const APPEARANCE_SET_PAGE_HISTORY_NAV = `appearance/${SET_PAGE_HISTORY_NAV}`;
export const APPEARANCE_SET_SEARCH_PANEL = `appearance/${SET_SEARCH_PANEL}`;
export const APPEARANCE_SET_FULLSCREEN = `appearance/${SET_FULLSCREEN}`;
export const APPEARANCE_SET_ISMOBILE = `appearance/${SET_ISMOBILE}`;
export const APPEARANCE_SET_PREFERENCES_VIEW = `appearance/${SET_PREFERENCES_VIEW}`;
export const APPEARANCE_SET_IS_PUBLIC_VIEW_MODE = `appearance/${SET_IS_PUBLIC_VIEW_MODE}`;
export const APPEARANCE_SET_IS_LOADING_IMAGES = `appearance/${SET_IS_LOADING_IMAGES}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_CLIENT = 'resetClient';
export const UPDATE_CLIENT = 'updateClient';
export const SET_ACCESS_DETAILS = 'setAccessDetails';

export const CLIENT_RESET_CLIENT = `client/${RESET_CLIENT}`;
export const CLIENT_UPDATE_CLIENT = `client/${UPDATE_CLIENT}`;
export const CLIENT_SET_ACCESS_DETAILS = `client/${SET_ACCESS_DETAILS}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_ACTIVATED_CEMODULES = 'resetActivatedCEModules';
export const BULK_ADD_ACTIVATED_CEMODULES = 'bulkAddActivatedCEModules';
export const UPDATE_ONE_ACTIVATED_CEMODULES = 'updateOneActivatedCEModules';

export const CEMODULES_RESET_ACTIVATED_CEMODULES = `activatedCEModules/${RESET_ACTIVATED_CEMODULES}`;
export const CEMODULES_BULK_ADD_ACTIVATED_CEMODULES = `activatedCEModules/${BULK_ADD_ACTIVATED_CEMODULES}`;
export const CEMODULES_UPDATE_ONE_ACTIVATED_CEMODULES = `activatedCEModules/${UPDATE_ONE_ACTIVATED_CEMODULES}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_PUBLISHED = 'resetPublished';
export const BULK_ADD_APPLIED_UPDATES = 'bulkAddAppliedUpdates';
export const BULK_ADD_COMPLISPACE_PUBLISHED = 'bulkAddComplispacePublished';
export const SET_PUBLISH_AT = 'setPublishAt';

export const PUBLICATIONS_RESET_PUBLISHED = `published/${RESET_PUBLISHED}`;
export const PUBLICATIONS_BULK_ADD_APPLIED_UPDATES = `published/${BULK_ADD_APPLIED_UPDATES}`;
export const PUBLICATIONS_BULK_ADD_COMPLISPACE_PUBLISHED = `published/${BULK_ADD_COMPLISPACE_PUBLISHED}`;
export const PUBLICATIONS_SET_PUBLISH_AT = `published/${SET_PUBLISH_AT}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_NAVIGATION = 'resetNavigation';
export const SET_NAVIGATION = 'setNavigation';
export const SET_NAVIGATION_OVER = 'setNavigationOver';
export const SET_CURRENT_PAGE = 'setCurrentPage';

export const NAVIGATION_RESET_NAVIGATION = `navigation/${RESET_NAVIGATION}`;
export const NAVIGATION_SET_NAVIGATION = `navigation/${SET_NAVIGATION}`;
export const NAVIGATION_SET_CURRENT_PAGE = `navigation/${SET_CURRENT_PAGE}`;
export const NAVIGATION_SET_NAVIGATION_OVER = `navigation/${SET_NAVIGATION_OVER}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_CLIENT_CONTEXT = 'resetClientContext';
export const BULK_ADD_CLIENT_CONTEXT_ITEMS = 'bulkAddClientContextItems';
export const BULK_UPDATE_IMPACTED_CLIENT_CONTEXT_ITEMS = 'bulkUpdateImpactedClientContextItems';
export const GET_CHILD_CONTEXT = 'getChildContext';
export const UPDATE_CLIENT_CONTEXT_ITEM = 'updateClientContextItem';
export const UPDATE_CHILD_CONTEXT_ITEM = 'updateChildContextItem';
export const BULK_ADD_PREVIOUS_CLIENT_CONTEXT_ITEMS = 'bulkAddPreviousClientContextItems';

export const CLIENT_CONTEXT_RESET_CLIENT_CONTEXT = `clientContext/${RESET_CLIENT_CONTEXT}`;
export const CLIENT_CONTEXT_BULK_ADD_CLIENT_CONTEXT_ITEMS = `clientContext/${BULK_ADD_CLIENT_CONTEXT_ITEMS}`;
export const CLIENT_CONTEXT_BULK_UPDATE_IMPACTED_CLIENT_CONTEXT_ITEMS = `clientContext/${BULK_UPDATE_IMPACTED_CLIENT_CONTEXT_ITEMS}`;
export const CLIENT_CONTEXT_UPDATE_CLIENT_CONTEXT_ITEM = `clientContext/${UPDATE_CLIENT_CONTEXT_ITEM}`;
export const CLIENT_CONTEXT_UPDATE_CHILD_CONTEXT_ITEM = `clientContext/${UPDATE_CHILD_CONTEXT_ITEM}`;
export const CLIENT_CONTEXT_BULK_ADD_PREVIOUS_CLIENT_CONTEXT_ITEMS = `clientContext/${BULK_ADD_PREVIOUS_CLIENT_CONTEXT_ITEMS}`;

// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_QUICK_LINK_CONTENT = 'resetQuickLinkContent';
export const ASSIGN_LIST = 'assignList';
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const RESET_PAGE_VISIBILITIES = 'resetPageVisibilities';
export const SET_INVISIBLE_PAGES = 'setInvisiblePages';
export const PAGE_VISIBILITIES_RESET_PAGE_VISIBILITIES = `pageVisibilities/${RESET_PAGE_VISIBILITIES}`;
export const PAGE_VISIBILITIES_SET_INVISIBLE_PAGES = `pageVisibilities/${SET_INVISIBLE_PAGES}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const SET_TOC_STATE = 'setTOCState';
export const INITIAL_DATA_MANAGER = 'initialDataManger';
export const UPDATE_MODULE_FINISHED = 'updateModuleFinished';
export const SET_MODULE_STATE = 'setModuleState';
export const PAGE_HISTORY = 'getPageHistory';
export const CLEAR_PAGE_HISTORY = 'clearPageHistory';
export const SET_PAGE_COMMIT_OID = 'setPageCommitOID';
export const SET_PAGE_COMMIT_TIMESTAMP = 'setPageCommitTimestamp';
export const SET_UNPUBLISHED_UPDATES_STATE = 'setUnpublishedUpdatesState';

export const DATA_SET_MODULE_STATE = `data/${SET_MODULE_STATE}`;
export const DATA_SET_TOC_STATE = `data/${SET_TOC_STATE}`;
export const DATA_CLEAR_PAGE_HISTORY = `data/${CLEAR_PAGE_HISTORY}`;
export const DATA_SET_PAGE_COMMIT_OID = `data/${SET_PAGE_COMMIT_OID}`;
export const DATA_SET_PAGE_COMMIT_TIMESTAMP = `data/${SET_PAGE_COMMIT_TIMESTAMP}`;
export const DATA_SET_UNPUBLISHED_UPDATES_STATE = `data/${SET_UNPUBLISHED_UPDATES_STATE}`;

// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
const IMAGE_UPLOADER = 'imageUploader';

export const IMAGE_UPLOAD = 'imageUpload';
export const IMAGE_REMOVE = 'imageRemove';
export const IMAGE_ADD = 'imageAdd';
export const IMAGE_DELETE_ALL = 'imageDeleteAll';

export const IMAGE_UPLOADER_IMAGE_UPLOAD = `${IMAGE_UPLOADER}/${IMAGE_UPLOAD}`;
export const IMAGE_UPLOADER_IMAGE_REMOVE = `${IMAGE_UPLOADER}/${IMAGE_REMOVE}`;
export const IMAGE_UPLOADER_IMAGE_ADD = `${IMAGE_UPLOADER}/${IMAGE_ADD}`;
export const IMAGE_UPLOADER_IMAGE_DELETE_ALL = `${IMAGE_UPLOADER}/${IMAGE_DELETE_ALL}`;

// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const SET_FEATURES = 'setFeatures';

export const FEATURES_SET_FEATURES = `features/${SET_FEATURES}`;
